// import React from "react";
// import "../styles/IndustriesWeServe.css";

// const IndustriesWeServe = () => {
//   return (
//     <section className="industries-section">
//       <div className="industries-container">
//         <h2>Industries We Serve</h2>
//         <p>We bring cloud transformation to a wide range of sectors, including:</p>
//         <div className="industries-circles">
//           {/* Big circles */}
//           <div className="circle big yellow" style={{ top: "50px", left: "50px" }}>
//             Financial<br ></br>Services
//           </div>
//           <div className="circle big pink" style={{ top: "150px", left: "150px" }}>
//             Healthcare &<br ></br>Life Sciences
//           </div>
//           <div className="circle big blue" style={{ top: "50px", left: "300px" }}>
//             Retail &<br ></br> Ecommerce
//           </div>
//           <div className="circle big green" style={{ top: "0px", left: "450px" }}>
//             Education &<br ></br> Public Sector
//           </div>
//           <div className="circle big teal" style={{ top: "150px", left: "550px" }}>
//             Technology &<br ></br> Startups
//           </div>
//           <div className="circle big orange" style={{ top: "200px", left: "400px" }}>
//             Manufacturing
//           </div>

//           {/* Medium circles */}
//           <div className="circle medium orange" style={{ top: "250px", left: "0px" }}></div>
//           <div className="circle medium blue" style={{ top: "300px", left: "100px" }}></div>
//           <div className="circle medium red" style={{ top: "200px", left: "250px" }}></div>
//           <div className="circle medium yellow" style={{ top: "300px", left: "350px" }}></div>

//           {/* Small decorative circles */}
//           <div className="circle small teal" style={{ top: "100px", left: "200px" }}></div>
//           <div className="circle small orange" style={{ top: "180px", left: "450px" }}></div>
//           <div className="circle small blue" style={{ top: "300px", left: "550px" }}></div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default IndustriesWeServe;









import React from "react";
import "../styles/IndustriesWeServe.css";

const IndustriesWeServe = () => {
  return (
    <section className="industries-section">
      <div className="industries-container">
        <h2 className="ind-main-title">Industries We Serve :</h2>
        <p className="ind-sub-title">We bring cloud transformation to a wide range of sectors, including:</p>
        
        <div className="industries-circles-wrapper">
          {/* --- Content Circles --- */}
          <div className="circle big yellow ind-financial">
            Financial<br />Services
          </div>
          <div className="circle big pink ind-healthcare">
            Healthcare &<br />Life Sciences
          </div>
          <div className="circle big blue ind-retail">
            Retail &<br />Ecommerce
          </div>
          <div className="circle big green ind-education">
            Education &<br />Public Sector
          </div>
          <div className="circle big teal ind-tech">
            Technology &<br />Startups
          </div>
          <div className="circle big orange ind-manufacturing">
            Manufacturing
          </div>

          {/* --- Decorative Dots (Hidden on Mobile) --- */}
          <div className="circle medium orange dec-1"></div>
          <div className="circle medium blue dec-2"></div>
          <div className="circle medium red dec-3"></div>
          <div className="circle medium yellow dec-4"></div>
          <div className="circle small teal dec-5"></div>
          <div className="circle small orange dec-6"></div>
          <div className="circle small blue dec-7"></div>
        </div>
      </div>
    </section>
  );
};

export default IndustriesWeServe;